import React, { useMemo } from 'react';
import SearchSelect from '../../libs/SearchSelect';
import useOffenseOptions from '../hooks/useOffenseOptions';

// The offense section is stored as "<ENACTMENT> / Sec <NUMBER>" (e.g. "EJSS / Sec 25").
// Show it in the requested form: "Seksyen <number> (<enactment>) - <name>".
const toOptionLabel = (item) => {
    const rawSection = (item?.section || '').toString().trim();
    const name = (item?.name || '').toString().trim();
    const match = rawSection.match(/^(.+?)\s*\/\s*Sec\.?\s*(\S+)/i);
    const head = match
        ? `Seksyen ${match[2].trim().toLowerCase()} (${match[1].trim()})`
        : rawSection;
    if (head && name) {
        return `${head} - ${name}`;
    }
    return name || head;
};

const SharedOffenseSelect = ({
    apiUrl,
    value,
    onChange,
    onItemSelected,
    label = 'Kesalahan Disyaki',
    placeholder = '-- Pilih Kesalahan Disyaki --',
    disabled = false,
}) => {
    const { items, isLoading } = useOffenseOptions({ apiUrl });

    const options = useMemo(() => (
        (items || []).map((item) => ({
            value: String(item.id),
            label: toOptionLabel(item),
        }))
    ), [items]);

    return (
        <SearchSelect
            label={label}
            value={value || ''}
            options={options}
            placeholder={isLoading ? 'Memuatkan kesalahan...' : placeholder}
            disabled={disabled}
            onChange={(nextValue) => {
                if (onChange) {
                    onChange(nextValue);
                }
                if (onItemSelected) {
                    const picked = (items || []).find((item) => String(item.id) === String(nextValue));
                    onItemSelected(picked || null);
                }
            }}
        />
    );
};

export default SharedOffenseSelect;
